module.exports = __webpack_public_path__ + "static/media/levels_4_1.fd695e01.svg";